
import Home from '../pages/Home'
//import ComingSoon from '../pages/ComingSoon'
//import BlogListLargeImage from '../pages/blog/BlogListLargeImage'
import NotFound from '../pages/elements/404'
import PrivacyPolicy from '../pages/PrivacyPolicy.vue'
import CovidResponse from '../pages/CovidResponse.vue'

export const routes = [
    {
        path:'/',
        name: 'Home',
        component: Home
    },
	{
		path:'/privacy',
		name: 'PrivacyPolicy',
		component: PrivacyPolicy
	},
	{
		path:'/covid',
		name: 'CovidResponse',
		component: CovidResponse
	},
    /*{
        path:'/coming-soon',
        name: 'ComingSoon',
        component: ComingSoon
    },
    {
        path:'/blog-list-large-image',
        name: 'BlogListLargeImage',
        component: BlogListLargeImage
    },*/
    {
        path:'*',
        name: 'NotFound',
        component: NotFound
    },
];